import { IntegrationStatusTypes } from 'module/api/integrations/salesforce/types';
import { User } from 'module/api/user/types';

export type FieldValue = {
  integrationFieldId: string;
  valueStr: string;
};

export type IntegrationConfig<SettingsMeta> = {
  integrationId: number;
  integrationType: string;
  domain: string;
  settingsMeta: SettingsMeta;
  integrationStatus: IntegrationStatusTypes;
  requiresReAuthentication?: boolean;
  meta: {
    oauthAuthenticatorAccountId: string;
    oauthAuthenticatorEmail: string;
    oauthAuthenticatorUsername: string;
    salesforceEnv?: string;
    oauthAuthenticatorAccountUrl?: string;
  };
  createdBy: User;
};

export enum AutomationErrorTypes {
  DuplicateAutomation = 'CONFLICTING_FIELD_VALUE',
}
export type AutomationCreationError = {
  code: AutomationErrorTypes;
  field: string;
  reason: string;
};

export type IntegrationProviderMeta = {
  authType: string;
  oauthUrl: string;
  oauthReauthUrl: string;
};

export enum ThirdpartyIntegrationType {
  Slack = 'slack',
  Jira = 'jira',
  Salesforce = 'salesforce',
  Rocketlane = 'rocketlane',
  Form = 'FORM',
}

export interface ExternalUser {
  id: string;
  integrationType: ThirdpartyIntegrationType;
  name: string;
  key: string;
  rlUserId: number;
}

export enum IntegrationSource {
  NativeIntegration = 'NATIVE_INTEGRATION',
}

export const IntegrationProvider = {
  Jira: 'jira',
  Zapier: 'zapier',
  SalesForce: 'salesforce',
  Slack: 'slack',
  Workato: 'workato',
  Hubspot: 'hubspot',
};

export const IntegrationConsumer = {
  Rocketlane: 'rocketlane',
};
